import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["description", "disabled", "ellipsis", "error", "icon", "id", "isLast", "isObfuscated", "isSelectedValueEllipsis", "label", "noRightIcon", "onClick", "rightIcon", "selectedValue", "testID", "UNSAFE_touchableProps", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import reformatObfuscation from '@bubble-ui/util-reformat-obfuscation';
import ActionIconChevronRight from '@bubble-ui/icon-action-chevron-right';
import SelectorOptionBase from '@bubble-ui/temp-selector-option-base';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import defaultTextStyles from '@bubble-ui/particle-default-text-styles';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { useDesignContext } from '@klarna/designtokens';
import { isNative } from '@bubble-ui/util-platform';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var DirectOption = _ref => {
  var {
      description,
      disabled,
      ellipsis,
      error,
      icon,
      id,
      isLast,
      isObfuscated,
      isSelectedValueEllipsis = true,
      label,
      noRightIcon,
      onClick,
      rightIcon,
      selectedValue,
      testID,
      UNSAFE_touchableProps,
      value
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(_objectSpread(_objectSpread({}, defaultColorVariables), defaultTextStyles));
  var formattedSelectedValue = isObfuscated ? reformatObfuscation(selectedValue) : selectedValue;
  var {
    rightIconStyle,
    leftIconStyle,
    descriptionWrapperStyle,
    titleStyle,
    paragraphSecondaryLightStyle
    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
  } = useStyleSheet(DirectOption, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    description,
    designContext,
    designVersion,
    disabled,
    ellipsis,
    error,
    icon,
    id,
    isLast,
    isObfuscated,
    isSelectedValueEllipsis,
    label,
    noRightIcon,
    onClick,
    rightIcon,
    selectedValue: formattedSelectedValue,
    testID,
    UNSAFE_touchableProps,
    value
  }));
  return /*#__PURE__*/React.createElement(SelectorOptionBase, _extends({
    id: id,
    testID: testID,
    leftIcon: icon && /*#__PURE__*/React.cloneElement(icon, leftIconStyle(icon)),
    rightIcon: rightIcon ? /*#__PURE__*/React.cloneElement(rightIcon, rightIconStyle) : !noRightIcon ? /*#__PURE__*/React.createElement(ActionIconChevronRight, rightIconStyle) : undefined,
    text: /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: ellipsis ? 1 : 0
    } : {}, {
      style: titleStyle
    }), label),
    description: description ? /*#__PURE__*/React.createElement(View, {
      style: descriptionWrapperStyle
    }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: ellipsis ? 1 : 0
    } : {}, {
      tag: "paragraph",
      style: paragraphSecondaryLightStyle
    }), description)) : undefined,
    rightText: formattedSelectedValue,
    isRightTextEllipsis: isSelectedValueEllipsis,
    value: value,
    disabled: disabled,
    onClick: onClick,
    isLast: isLast,
    UNSAFE_touchableProps: UNSAFE_touchableProps
  }, props));
};
DirectOption.displayName = 'SelectorDirectOption';
export default withProvisionalOverrideFromContext(DirectOption);
//# sourceMappingURL=index.js.map